import React, { Component } from 'react'
import history from '../../routes/history';
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';
import { TaskSegment, getTaskTypeIdById } from '../../redux/actions/data-action';
import { Box } from '../../third-party-components/material-ui';

import {
    AssessmentContainer,
    AssessmentBody,
    AssessmentContent,
    AssessmentNavigationPrevious,
    AssessmentNavigationNext,
    AssessmentFooter
} from './common';

const toNext = "/Assessment/Outcome/Items/1";

class AssessmentOutcomeInstruction extends Component {
    componentDidMount() {
        window.history.pushState(null, null, history.location.href);
        window.onpopstate = function(event) {
            history.go(1);
        }; 
    }

    getLastTaskTypeLink() {
        const { tasks } = this.props;
        const currentTasks = tasks[tasks.length - 1];
        const taskType = getTaskTypeIdById(currentTasks.id);

        let lastIndex = currentTasks.length;

        for (let i = currentTasks.tasks.length - 1; i >= 0; i--) {
            if (currentTasks.tasks[i].skipped) {
                continue;
            } else {
                lastIndex =  i + 1;
                break;
            }
        }

        return `/Assessment/Tasks/${taskType.type}/${TaskSegment.TASK}/${lastIndex}`;
    }

    render() {
        return (
            <AssessmentContainer>
                <AssessmentBody>
                    <AssessmentNavigationPrevious />
                    <AssessmentContent>
                      The following are a few additional questions. Please answer these questions about your child. Keep in mind how your child usually behaves.<br/>
                      If you have seen your child do the behavior a few times, but they don't usually do it, then please answer no.<br/>
                      Please respond yes or no for every question.
                    </AssessmentContent>
                    <AssessmentNavigationNext to={toNext} />
                </AssessmentBody>
                <AssessmentFooter></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
    tasks: state.data.tasks,
})

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentOutcomeInstruction));